var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClarity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0,
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m309.13 309.57 30.939 30.168"
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m351.75 183.79a168.37 168.25 0 0 1-167.98 168.25 168.37 168.25 0 0 1-168.77-167.46 168.37 168.25 0 0 1 167.18-169.04 168.37 168.25 0 0 1 169.56 166.66",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m177.6 83.522c39.855-12.396 115.49 40.919 107.47 105.83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m499.46 451.35-128.39-133.68c-11.084-21.897-63.53 39.171-55.251 47.154 0.99262 0.95701 0.15398 2.6948 0.50973 3.9316l136 128.98z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m352.7 403.13 49.852-46.905"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClarity);
export default __webpack_public_path__ + "static/media/clarity.94a590ec3f006d87ee763fd42d2ecfee.svg";
export { ForwardRef as ReactComponent };